"use client";

import { useTranslation } from "react-i18next";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type AnalyticsRange = 7 | 30 | 90;

interface TimeRangeSelectorProps {
  value: AnalyticsRange;
  onChange: (v: AnalyticsRange) => void;
}

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  const { t } = useTranslation("analytics");
  return (
    <ToggleGroup
      type="single"
      value={String(value)}
      onValueChange={(v) => {
        if (!v) return;
        const n = Number(v);
        if (n === 7 || n === 30 || n === 90) onChange(n);
      }}
      variant="outline"
      size="sm"
    >
      <ToggleGroupItem value="7" aria-label={t("timeRange.last7days")}>
        7d
      </ToggleGroupItem>
      <ToggleGroupItem value="30" aria-label={t("timeRange.last30days")}>
        30d
      </ToggleGroupItem>
      <ToggleGroupItem value="90" aria-label={t("timeRange.last90days")}>
        90d
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
